export type RegisterProgressBarProps = {
  currentStep: number
  totalSteps: number
}

export function RegisterProgressBar({ currentStep, totalSteps }: RegisterProgressBarProps) {
  const progressPercent = (currentStep / totalSteps) * 100
  return (
    <div data-testid="register-progress-bar" className="px-6 py-5">
      <p className="mb-2 text-base text-muted-foreground">
        Step {currentStep} of {totalSteps}
      </p>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={totalSteps}
        aria-valuenow={currentStep}
        className="h-1.5 w-full overflow-hidden rounded-sm bg-muted"
      >
        <div
          data-testid="register-progress-fill"
          className="h-full rounded-sm bg-primary transition-[width] duration-300 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  )
}
